import { createRef } from 'react';
import { ProductGallery as SourceProductGallery } from 'SourceComponent/ProductGallery/ProductGallery.component';
import { withRouter } from 'react-router';
import ConfigQuery from 'Query/Config.query';
import { fetchQuery } from 'Util/Request';
import Slider from 'Component/Slider';
import ProductStickers from 'Component/ProductStickers';
import ProductGalleryBaseImage from 'Component/ProductGalleryBaseImage';
import { TransformWrapper } from 'react-zoom-pan-pinch';

export class ProductGallery extends SourceProductGallery {

    state = {
        stickerData: null,
        scrollEnabled: true
    };

    componentDidMount() {
        this.fetchStickerData();
        this.updateSharedDestinationElement();
    }

    // Fetch sticker data from API
    fetchStickerData = async () => {
        try {
            const stickerData = await fetchQuery(ConfigQuery.getProductCardStickerData());
            this.setState({ stickerData });
        } catch (error) {
            console.error('Error fetching sticker data:', error);
        }
    };

    renderAdditionalPictures() {
        const { gallery } = this.props;

        return (
            <div block="ProductGallery" elem="Additional">
                { gallery.map(this.renderAdditionalPicture) }
            </div>
        );
    }

    renderProductStickers() {
        const {
            productStickers: {
                new_from_date,
                new_to_date,
                special_from_date,
                special_to_date,
                price,
                cartRuleSpecialPrice,
                sticker_info,
                sticker_promo,
                sticker_promo_account,
                stickersValues,
                sku
            }
        } = this.props;

        return (
            <ProductStickers
                price={ price }
                newFromDate={ new_from_date }
                newToDate={ new_to_date }
                specialFromDate={ special_from_date }
                specialToDate={ special_to_date }
                stickerInfo={ sticker_info }
                stickerPromo={ sticker_promo }
                stickerPromoAccount={ sticker_promo_account }
                stickerParent={ stickersValues }
                cartRuleSpecialPrice={ cartRuleSpecialPrice }
                sku = { sku }
            />
        );
    }

    // Determine if the sticker should be displayed
    shouldDisplaySticker = (sku) => {
        const { stickerData } = this.state;

        if (!stickerData || !stickerData.product_card_sticker || !stickerData.product_card_sticker.enabled || !stickerData.product_card_sticker.sku_list) {
            return false;
        }

        const skuList = stickerData.product_card_sticker.sku_list.split(',').map(s => s.trim());
        return skuList.includes(sku);
    };

    // Render the sticker image
    renderSticker() {
        const { stickerData } = this.state;

        if (!stickerData || !stickerData.product_card_sticker.image) {
            return null;
        }

        return (
            <img
                className="BottomLabel"
                src={stickerData.product_card_sticker.image}
                alt="Sticker"
            />
        );
    }

    renderImage(mediaData, index) {
        const { isZoomEnabled, handleZoomChange, disableZoom, productName } = this.props;
        const { scrollEnabled } = this.state;

        return (
            <TransformWrapper
                key={ index }
                onZoomChange={ handleZoomChange }
                onWheelStart={ this.onWheelStart }
                onWheel={ this.onWheel }
                wheel={ { limitsOnWheel: true, disabled: !scrollEnabled } }
                //   doubleClick={ { mode: 'reset' } }
                pan={ {
                    disabled: !isZoomEnabled,
                    limitToWrapperBounds: true,
                    velocity: false
                } }
                options={ {
                    limitToBounds: true,
                    minScale: 1
                } }
            >
                { ({
                       scale,
                       previousScale,
                       resetTransform,
                       setTransform
                   }) => {
                    if (scale === 1 && previousScale !== 1) {
                        resetTransform();
                    }

                    return (
                        <ProductGalleryBaseImage
                            setTransform={ setTransform }
                            index={ index }
                            mediaData={ mediaData }
                            scale={ scale }
                            previousScale={ previousScale }
                            disableZoom={ disableZoom }
                            isZoomEnabled={ isZoomEnabled }
                            productName={ productName }
                        />
                    );
                } }
            </TransformWrapper>
        );
    }

    renderSlider() {
        const {
            gallery,
            activeImage,
            isZoomEnabled,
            onActiveImageChange,
            sku
        } = this.props;

        return (
            <div ref={this.imageRef}>
                {this.renderProductStickers()}
                <div>
                    <Slider
                        ref={this.sliderRef}
                        mix={{block: 'ProductGallery', elem: 'Slider'}}
                        showCrumbs
                        activeImage={activeImage}
                        onActiveImageChange={onActiveImageChange}
                        isInteractionDisabled={isZoomEnabled}
                    >
                        {gallery.map(this.renderSlide)}
                    </Slider>
                    {this.shouldDisplaySticker(sku) && this.renderSticker()}
                </div>
            </div>
        );
    }
}

export default withRouter(ProductGallery);
